/**
 * Check if value is url
 * This is simple validation which check if there are spaces and if http(s) protocol is applied
 */
export const isSimpleUrl = (value?: string) => !value || /^https?(:\/\/)(\S+)$/.test(value.trim());

/**
 * Check if value doesn't have any spaces
 */
export const hasNoSpaces = (value?: string) => !value || !/\s/.test(value.trim());

/**
 * Check if url path has correct format
 */
export const isUrlPath = (value?: string) =>
  !value || /^([\w-%/.[\]]+)?(\?([\w-]+(=[\w-%.]*)?(&[\w-]+(=[\w-%.]*)?)*)?)?$/.test(value.trim());

/**
 * Check if value has app schema format - if it has :// at the end and no spaces
 */
export const isAppScheme = (value?: string) => !value || /^(\S+)(:\/\/)$/.test(value.trim());

/**
 * Check if value is of a app schema format or if it's an url
 */
export const isAndroidAppScheme = (value?: string) => isAppScheme(value) || isSimpleUrl(value);

/**
 * Transform object to query string
 */
export const stringify = (data: { [key: string]: unknown }, { partialEncode = false } = {}) => {
  let args = ['=', '&'];
  if (partialEncode) args = args.map(encodeURIComponent);
  return Object.entries(data)
    .filter(([, value]) => !!value)
    .map(pair => pair.join(args[0]))
    .join(args[1]);
};

/**
 * Redirect user to login page
 */
export const redirectToLogin = () => {
  window.location.href = '/#/login';
};
